export default __webpack_public_path__ + "static/media/telework.3ddc2f49.svg";